import type { SVGProps } from "react";

// the line icons of the design (24×24 grid, currentColor strokes)
const PATHS = {
  wheat: (
    <>
      <path d="M12 22V7" />
      <path d="M12 7c-1.8-.9-2.8-2.6-2.8-4.6 1.8.2 2.8 2 2.8 4.6zM12 7c1.8-.9 2.8-2.6 2.8-4.6-1.8.2-2.8 2-2.8 4.6z" />
      <path d="M12 12.5c-2-.8-3.4-2.4-3.4-4.3 2 .3 3.4 1.9 3.4 4.3zM12 12.5c2-.8 3.4-2.4 3.4-4.3-2 .3-3.4 1.9-3.4 4.3z" />
      <path d="M12 17.5c-2-.8-3.4-2.4-3.4-4.3 2 .3 3.4 1.9 3.4 4.3zM12 17.5c2-.8 3.4-2.4 3.4-4.3-2 .3-3.4 1.9-3.4 4.3z" />
    </>
  ),
  home: <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />,
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </>
  ),
  sprout: (
    <>
      <path d="M12 21V11" />
      <path d="M12 11c0-4 3-6.5 7.5-6.5 0 4-3 6.5-7.5 6.5z" />
      <path d="M12 14.5c0-3-2.3-5.2-6-5.2 0 3 2.3 5.2 6 5.2z" />
      <path d="M7 21h10" />
    </>
  ),
  tree: (
    <>
      <circle cx="12" cy="5" r="2.2" />
      <circle cx="6" cy="19" r="2.2" />
      <circle cx="18" cy="19" r="2.2" />
      <path d="M12 7.2V12M6 16.8V15a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1.8" />
    </>
  ),
  box: (
    <>
      <rect x="3" y="4" width="18" height="5" rx="1" />
      <path d="M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9M10 13h4" />
    </>
  ),
  flask: (
    <>
      <path d="M9 3h6M10 3v6l-5.2 9.2A2 2 0 0 0 6.5 21h11a2 2 0 0 0 1.7-2.8L14 9V3" />
      <path d="M7.4 15h9.2" />
    </>
  ),
  chart: <path d="M5 20V11M11 20V5M17 20v-7M3 20h18" />,
  sliders: (
    <>
      <path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1" />
      <circle cx="15" cy="6" r="2" />
      <circle cx="9" cy="12" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </>
  ),
  chevronDown: <path d="M6 9l6 6 6-6" />,
  chevronRight: <path d="M9 6l6 6-6 6" />,
  jobs: <path d="M12 3v3M12 18v3M4.6 6.6l2.1 2.1M17.3 15.3l2.1 2.1M3 12h3M18 12h3M4.6 17.4l2.1-2.1M17.3 8.7l2.1-2.1" />,
  help: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.3a2.6 2.6 0 0 1 5 .9c0 1.7-2.5 2.2-2.5 3.8M12 17h.01" />
    </>
  ),
  pin: <path d="M15 4.5l-4 4-4 1.5-1.5 1.5 7 7 1.5-1.5 1.5-4 4-4M9 15l-4.5 4.5M14.5 4l5.5 5.5" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  back: <path d="M15 6l-6 6 6 6" />,
  check: <path d="M5 12l5 5 9-10" />,
  alert: (
    <>
      <path d="M12 4l9 16H3z" />
      <path d="M12 10v4M12 17h.01" />
    </>
  ),
  download: <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />,
  upload: <path d="M12 20V9M7 14l5-5 5 5M5 4h14" />,
  plus: <path d="M12 5v14M5 12h14" />,
  undo: <path d="M9 14L4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3" />,
  barcode: <path d="M4 6v12M7 6v12M10 6v12M14 6v12M16 6v12M20 6v12" />,
  history: (
    <>
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5M12 7v5l3 2" />
    </>
  ),
  logout: <path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 16l-4-4 4-4M6 12h10" />,
  phone: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M11 18h2" />
    </>
  ),
  printer: (
    <>
      <path d="M7 9V4h10v5" />
      <rect x="4" y="9" width="16" height="7" rx="1" />
      <path d="M7 14h10v6H7z" />
    </>
  ),
  arrowLeft: <path d="M19 12H5M11 6l-6 6 6 6" />,
  arrowRight: <path d="M5 12h14M13 6l6 6-6 6" />,
  arrowUp: <path d="M12 19V5M6 11l6-6 6 6" />,
  // a drag handle: two columns of three dots
  grip: (
    <g fill="currentColor" stroke="none">
      <circle cx="9" cy="6" r="1.6" />
      <circle cx="15" cy="6" r="1.6" />
      <circle cx="9" cy="12" r="1.6" />
      <circle cx="15" cy="12" r="1.6" />
      <circle cx="9" cy="18" r="1.6" />
      <circle cx="15" cy="18" r="1.6" />
    </g>
  ),
  arrowDown: <path d="M12 5v14M6 13l6 6 6-6" />,
  trash: <path d="M5 7h14M10 7V5h4v2M7 7l1 13h8l1-13" />,
  more: <path d="M6 12h.01M12 12h.01M18 12h.01" strokeWidth={3} />,
  circle: <circle cx="12" cy="12" r="7.5" />,
  filter: <path d="M4 6h16M7 12h10M10 18h4" />,
  columns: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="1.5" />
      <path d="M9 4v16M15 4v16" />
    </>
  ),
  edit: <path d="M4 20h4L19 9l-4-4L4 16v4M13 7l4 4" />,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}
